import { createClient } from "@supabase/supabase-js";

const isDemo = process.env.REACT_APP_DEMO_MODE === "true";

// In demo mode, MSW intercepts every request before it reaches the network, so
// placeholder credentials are fine — the real values are never used.
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  (isDemo ? "https://demo.supabase.co" : null);
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  (isDemo ? "demo-anon-key" : null);

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "Supabase auth disabled: set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env"
  );
}

export const supabase =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
          // PKCE exchanges a one-time code instead of putting tokens in the URL hash.
          flowType: "pkce",
          detectSessionInUrl: true,
          persistSession: true,
          autoRefreshToken: true,
        },
      })
    : null;
